import { primaryColor } from './colors';
import { createTheme } from '@material-ui/core';

export const theme = createTheme({
    fontFamily: 'Lato, sans-serif',
    palette: {
        primary: {
            main: primaryColor,
        },
    },
});